<template>
  <div class="role-page full-height">
      <table-con>
        <div slot="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
             <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>库位配置</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div slot="search">
          <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title" style="width:110px">库位编号:</div>
            <div class="flex1">
              <el-input
                placeholder="请输入内容"
                clearable
                v-model="queryInfo.locatorNo"
                size = "small"
                @keyup.enter.native="searchList"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="5" class="display-row" >
            <div class="query-title" style="text-align:right">库位类别:</div>
            <div class="flex1" >
              <el-select v-model="queryInfo.locatorCategory" placeholder="请选择" size="small" clearable>
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="13" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;floate:right" >
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-green" @click="insert">新增库位</el-button>
            </div>
          </el-col>
        </el-row>
        </div>
        <div slot="table" class="full-height display-col">
           <el-table
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            :data="recordList"
            border
            height="550"
           >
           <el-table-column  prop="id" align="center" label="ID" width="40"></el-table-column>
           <el-table-column
           prop="locatorNo"
           label="库位编号"
           align="center"
           width="160px">
           </el-table-column>
            <el-table-column
              prop="locatorCategory"
              label="库位类别"
              align="center"
              width="100px">
              <template v-slot="scope">
              {{categoryShow(scope.row.locatorCategory)}}
            </template>
            </el-table-column>
             <el-table-column
             prop="locatorDes"
              label="库位说明">
            </el-table-column>
             <el-table-column
              prop="sortKey"
              label="排序值"
              align="center"
              width="100px">
            </el-table-column>
             <el-table-column
              prop="locatorLength"
              label="长-宽-高（CM）"
              align="center"
              width="200px">
              <template slot-scope="scope">
                {{scope.row.locatorLength}}—{{scope.row.locatorWidth}}—{{scope.row.locatorHeight}}
              </template>
            </el-table-column>
             <el-table-column
                 prop="code"
                 label="条码"
                 align="center"
                 width="200px">
               <template slot-scope="scope">
                 <div>
                   <js-barcode
                     :value="scope.row.id"
                     :text="scope.row.locatorNo"
                     :valid=true
                   ></js-barcode>
                   <el-button class="list-btn-four btn-blue" @click="handleBig(scope.row)">放大</el-button>
                 </div>
               </template>
             </el-table-column>

             <el-table-column
              prop="useStatus"
              label="启用状态"
              align="center"
              :index="indexMethod"  sortable
              width="100px">
              <template v-slot="scope">
              {{statusShow(scope.row.useStatus)}}
            </template>
            </el-table-column>

             <el-table-column
               prop="code"
               label="库存订单"
               align="center"
               width="100px">
               <template slot-scope="{row}">
                 <div style="color: #409EFF;cursor: pointer;" @click="handleLook(row)">
                   查看
                 </div>
               </template>
             </el-table-column>
             <!--<el-table-column
               prop="code"
               label="库存订单"
               align="center"
               width="300px">
               <template slot-scope="{row}">
                 <div v-for="(item,index) in row.oytqcConfigLocatorOrder" :key="index" style="color: #409EFF;">
                  {{item.orderId}}-{{item.addTime}}-{{item.addUserName}}
                 </div>
               </template>
             </el-table-column>
             <el-table-column
               prop="code"
               label="商品数量(件)"
               align="center"
               width="110px">
               <template slot-scope="{row}">
                 &lt;!&ndash;{{row.newNumber}}&ndash;&gt;
                 <div v-for="(item,index) in row.oytqcConfigLocatorOrder" :key="index">
                   {{item.goodsSizeIn - (item.goodsSizeOut || 0) }}
                 </div>
               </template>
             </el-table-column>-->
            <el-table-column label="操作" align="center" width="100">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button
                class="list-btn btn-deepblue"
                @click="update(scope.row)">
                编辑
                </el-button>
                <el-button
                class="list-btn btn-warn"
                @click="deleteL(scope.row)">
                删除
                </el-button>
              </div>
            </template>
          </el-table-column>
          </el-table>
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
        </div>
      </table-con>
       <!-- 修改 -->
        <el-dialog
      :title="dialogTitle"
      :visible.sync="updateDialogVisible"
      width="30%"
      @close="updateDialogClose"
    >
        <el-form :model="locatorInfo" :rules="rules" ref="locatorInfo" label-width="120px" class="demo-locatorInfo">
            <el-form-item label="库位编号" prop="locatorNo" >
            <el-input v-model="locatorInfo.locatorNo"></el-input>
            </el-form-item>
            <el-form-item label="库位类别" prop="locatorCategory">
            <el-select v-model="locatorInfo.locatorCategory" placeholder="请选择" size="small" clearable>
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="库位说明" prop="locatorDes">
            <el-input v-model="locatorInfo.locatorDes"></el-input>
            </el-form-item>
            <el-form-item label="长-宽-高（CM）">
            <el-input v-model="locatorInfo.locatorLength" style="width:70px;margin-right:10px"></el-input>
            <el-input v-model="locatorInfo.locatorWidth" style="width:70px;margin-right:10px"></el-input>
            <el-input v-model="locatorInfo.locatorHeight" style="width:70px;margin-right:10px"></el-input>
            </el-form-item>
            <el-form-item label="排序值" prop="sortKey">
            <el-input v-model="locatorInfo.sortKey"></el-input>
            </el-form-item>
            <el-form-item label="启用状态" prop="useStatus">
            <el-switch
                 v-model="locatorInfo.useStatus"
                 active-text="启用"
                 active-value="0"
                 inactive-color="#909399"
                 inactive-text=""
                 inactive-value="1">
            </el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="form-btn btn-gray" @click="clearForm">取 消</el-button>
          <el-button  class="form-btn btn-blue" @click="updateSave('locatorInfo')">提 交</el-button>

        </div>
        </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'
import JsBarcode from '@/components/JsBarcode'
export default {
  name: 'locator',
  // name: 'configuration/Locator',
  components: { tableCon, JsBarcode },
  data() {
    return {
      locatorInfo: {
          id:'',
          locatorNo:'',
          locatorCategory:'',
          locatorDes:'',
          locatorLength:'',
          locatorWidth:'',
          locatorHeight:'',
          sortKey:'',
          useStatus:''
        },
      queryInfo:{
        locatorNo:'',
        locatorCategory:'',
        pageSize:10,
        pageNum:1
      },
      dialogTitle:'',
      recordList:[],
      total:0,
      categoryOptions:[
        {
          value: '0',
          label: '货架'
        }, {
          value: '1',
          label: '堆放区'
        }
      ],
      rules:{
      locatorNo:[
          {required:true,message:'请输入库位编号',trigger:'blur'}
      ],
      locatorCategory:[
          {required:true,message:'请选择库位类别',trigger:'blur'}
      ]
          },
      updateDialogVisible:false,
    }
  },
  methods:{
    handleBig(row){
      this.$modalDialog(() => import('./cmp/big-code.vue'), {
        value: row.id,
        text: row.locatorNo,
        valid: true
      }).then(
          () => {
          },
          () => {
          }
      )
    },
    // 查看库存订单
    handleLook(row){
      this.$modalDialog(() => import('./cmp/stock-order.vue'), {
        tableData: row.oytqcConfigLocatorOrder
      }).then(
          () => {
          },
          () => {
          }
      )
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    updateSave(formName){    //保存按钮
        var my = this;
      //保存按钮
      this.$refs.locatorInfo.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          var url = "cms/locator/insertAndEdit";
          const { data: res } = await my.$http.post(url, my.locatorInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getrecordList();
            my.updateDialogVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    clearForm() {   //弹窗的取消按钮
      this.initForm();
      this.updateDialogVisible=false;
      },
    initForm(){   //初始化弹窗的内容
      this.locatorInfo = {
         id:'',
         locatorNo:'',
          locatorCategory:'',
          locatorDes:'',
          locatorLength:'',
          locatorWidth:'',
          locatorHeight:'',
          sortKey:'',
          useStatus:''
      };
    },
    searchList(){    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
    },
    async getrecordList(){
      console.log(this.queryInfo);
      const {data:res} = await this.$http.get('cms/locator/list',{params:this.queryInfo});
      console.log(res);
      this.recordList = res.data.list.map(v=>{
        let newNumber = 0
        for (let i = 0; i < v.oytqcConfigLocatorOrder.length; i++) {
          newNumber += v.oytqcConfigLocatorOrder[i].goodsSizeAll
        }
        return{
          ...v,
          newNumber
        }
      });
      this.total = res.data.total;
      console.log(this.total);
    },
    queryInfoClear(){    //清空
      this.queryInfo = {
        locatorNo:'',
        locatorCategory:'',
        pageSize:10,
        pageNum:1
      }
    },
    statusShow(status){
      switch(status){
        case '1':
        return '禁用'
        break;
        case '0':
        return '启用'
        break;
      }
    },
    categoryShow(status){
      switch(status){
        case '1':
        return '堆放区'
        break;
        case '0':
        return '货架'
        break;
      }
    },
    update(row){     //编辑
      this.dialogTitle='编辑';
      this.updateDialogVisible = true;
      this.getrecordList;
      this.locatorInfo = {
         id:row.id,
         locatorNo:row.locatorNo,
          locatorCategory:row.locatorCategory,
          locatorDes:row.locatorDes,
          sortKey:row.sortKey,
          locatorLength:row.locatorLength,
          locatorWidth:row.locatorWidth,
          locatorHeight:row.locatorHeight,
          useStatus:row.useStatus
      };
    },
    insert(row){     //新增
     this.dialogTitle='新增';
     this.updateDialogVisible = true;
     this.getrecordList;
     this.locatorInfo = {
          id:'',
          locatorNo:'',
          locatorCategory:'',
          locatorDes:'',
          sortKey:'',
          locatorLength:'',
          locatorWidth:'',
          locatorHeight:'',
          useStatus:'0'
      };
    },
    async deleteL(row){
      console.log(row.id);
      var url = 'cms/locator/delete';
      const {data:res} = await this.$http.post(url,{id:row.id});
      if(res.code == 200){
        this.$message({
          type:'success',
          message:res.message
        })
      }
      else{
        this.$message({
          type:'warning',
          message:res.message
        })
      }
      this.getrecordList();
    },
    updateDialogClose(){    //关闭弹窗
      console.log('close');
      this.updateDialogVisible = false;
    },
  },
  created() {
    this.getrecordList();
  }
};
</script>

<style lang="less" scoped>
  .role-page > .search-container{
    height: 60px !important;
  }
  .el-table .el-button--small{
    padding: 4px 10px;
  }
</style>
